/*jshint loopfunc: true */
define('editor/list/index',['jquery', 'plugins/http', 'knockout', 'durandal/app', 'plugins/router', 'moment', 'durandal/system', 'durandal/composition', 'durandal/activator'], function ($, http, ko, app, router, moment, system, composition, activator) {
    var viewmodel = function () {
        var self = this;

        self.skipPages = 0;
        self.moreMaps = ko.observable(true);
        self.editorMaps = ko.observableArray();
        self.searchPhrase = ko.observable('');
        self.editorMaps.extend({
            infinitescroll: {}
        });
        self.emptyMessage = ko.observable();
        self.isCompanyAdmin = ~app.currentUser.claims.indexOf('CompanyAdmin');
        self.modalContainer = null;
        self.previewContainer = null;
        self.previewDialog = null;

        self.create = function () {
            router.navigate('/editor/new');
        };

        self.open = function(editorMap) {
            router.navigate('/editor/edit/' + editorMap.id);
        };

        self.preview = function (editorMap) {
            self.fetchEditorMap(editorMap.id)
                .then(self.initialisePreviewModal);
        };

        self.fetchEditorMap = function (id) {
            var url = "/api/editor/edit/" + id;

            return http.get(url)
                .then(self.processMapData)
                .fail(app.showError);
        };

        self.initialisePreviewModal = function(editorMap) {
            var body = $('body');

            self.modalContainer = $('<div id="mapforge-custom-dialog" class="list-modal"></div>').appendTo(body);
            self.previewContainer = $('<div class="inner animated fadeInRight"></div>').appendTo(self.modalContainer);

            system.acquire('editor/render/iframe')
                .then(function (module) {
                    var dialogActivator = activator.create(),
                        moduleInstance = system.resolveObject(module),
                        activationData = [editorMap.data.editorMap, self.destroyPreview];

                    dialogActivator.activateItem(moduleInstance, activationData)
                        .then(function () {
                            var settings = {
                                model: moduleInstance,
                                activate: false,
                                transition: false
                            };

                            self.previewDialog = {
                                close: function () {
                                    dialogActivator.deactivateItem(moduleInstance, true);
                                }
                            };

                            composition.compose(self.previewContainer.get(0), settings);
                        });
                });
        };

        self.loadHistory = function(editorMap) {
            var url = '/api/editor/history/' + editorMap.id;

            return http.get(url).then(function(response) {
                if (response.success) {
                    editorMap.history([]);
                    for (var i = 0; i < response.data.history.length; i++) {
                        var history = {
                            historyId: response.data.history[i].historyId,
                            editUrl: '/editor/edit/' + editorMap.id,
                            dateCreated: moment(response.data.history[i].dateCreated).format('DD MMM YYYY, h:mm:ss a'),
                            editedBy: response.data.history[i].editedBy
                        };
                        editorMap.history.push(history);
                    }
                    
                    editorMap.historyLoaded(true);
                } else {
                    app.showError(response, "Unexpected Error", "Unable to retrieve map");
                }
            }).fail(app.showError);
        };

        self.onLoadHistorySnapshot = function (model) {
            var editUrl = model.editUrl;
            var url = "/api/editor/drafts";
            var data = {
                historyId: model.historyId
            };

            http.post(url, data)
                .then(function () {
                    router.navigate(editUrl);
                }).fail(app.showError);
        };

        self.formatAuthor = function (editorMap) {
            return editorMap.authorName === '' ? editorMap.authorEmail : editorMap.authorName;
        };

        self.formatUpdatedBy = function (editorMap) {
            return editorMap.updatedByName === '' ? editorMap.updatedByEmail : editorMap.updatedByName;
        };

        self.activate = function () {
            self.loadMore();
        };

        self.destroyPreview = function () {
          if (!self.previewContainer) {
            return;
          }

          self.previewContainer.attr('class', 'inner animated fadeOutRight');

          setTimeout(function () {
              self.previewDialog.close();
              self.modalContainer.remove();
              self.previewContainer.remove();
          }, 500);
        };

        self.deactivate = function () {
            self.destroyPreview();
        };

        self.clearSearch = function () {
            if (self.searchPhrase()) {
                self.searchPhrase('');
                self.newSearch();
            }
        };

        self.newSearch = function() {
            self.skipPages = 0;
            self.emptyMessage('');
            self.editorMaps.removeAll();
            
            self.loadMore();
        };

        self.loadMore = function () {
            if (router.activeInstruction().fragment === 'editor/list/all') {
                self.search('/all');
            } else {
                self.search();
            }
        };

        self.search = function (filter) {
            var url = "/api/editor/search" + (filter && typeof(filter) === 'string' ? filter : '');
            var data = {
                phrase: self.searchPhrase()
            };
            
            if (self.skipPages > 0) {
                data.skipPages = self.skipPages;
            }

            return http.post(url, data)
                .then(function (response) {
                    if (response.data.matches.length) {
                        
                        for (var i = 0; i < response.data.matches.length; i++) {
                            var map = response.data.matches[i];
                            map.isLocked = ko.observable(map.locked);
                            map.history = ko.observableArray([]);
                            map.historyLoaded = ko.observable(false);
                        }

                        ko.utils.arrayPushAll(self.editorMaps, response.data.matches);
                        self.moreMaps(response.data.more);

                        if (self.moreMaps()) {
                            self.skipPages++;
                        }
                        
                    } else {
                        self.emptyMessage(self.searchPhrase().length ? 'No matches' : 'You have not created any maps yet');
                    }
                }).fail(app.showError);
        };

        self.clone = function (editorMap, e) {
            e.stopPropagation();

            app.showMessage('Are you sure you want to clone this map? The clone will become editable by your team.', 'Clone Map', ['Clone', 'Cancel']).then(function (answer) {
                if (answer === 'Clone') {
                    var url = '/api/editor/clone/' + editorMap.id;
                    http.post(url).then(function(response) {
                        if (response.success) {
                            self.open(response.data.editorMap);
                        } else {
                            app.showMessage(response.data.error, 'Cannot Clone');
                        }
                    }).fail(app.showError);
                }
            });
        };

        self.delete = function (editorMap, e) {
            e.stopPropagation();
            
            app.showMessage('Are you sure you want to delete this map? This cannot be undone and the whole team will lose the map.', 'Delete Map', ['Delete', 'Cancel']).then(function(answer) {
                if (answer === 'Delete') {
                    var url = '/api/editor/delete/' + editorMap.id;
                    http.post(url).then(function (response) {
                        if (response.success) {
                            self.editorMaps.remove(editorMap);
                            app.showMessage('The map has been deleted.', 'Delete Complete');
                        } else {
                            app.showMessage(response.error, 'Cannot Delete');
                        }
                    }).fail(app.showError);
                }
            });
        };

        self.clearLock = function (editorMap, e) {
            e.stopPropagation();
            
            var url = '/api/editor/edit/heartbeat/release',
                data = {
                    editorMapId: editorMap.id
                };
            
            http.post(url, data)
                .then(function (response) {
                    if (response.success) {
                        editorMap.isLocked(false);
                    } else {
                        app.showMessage(response.error, 'Cannot Unlock');
                    }
                }).fail(app.showError);
        };
    };

    return viewmodel;
});

